import React from "react"
import PropTypes from "prop-types"
import { CustomerShape, InvestmentShape } from "@shapes"

import { CUSTOMER_NAME_PERSONAL } from "../CustomerCreateButton"
import PersonalCustomerVerificationButton from "./PersonalCustomerVerificationButton"
import BusinessCustomerVerificationButton from "./BusinessCustomerVerificationButton"


const CustomerVerificationButton = (props) => {
  const { customer } = props

  const { name } = customer

  const isPersonalCustomer = name === CUSTOMER_NAME_PERSONAL

  if (isPersonalCustomer) {
    return <PersonalCustomerVerificationButton {...props} />
  }

  return <BusinessCustomerVerificationButton {...props} />
}

CustomerVerificationButton.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape()
  ]),
  customer: CustomerShape,
  onSuccess: PropTypes.func,
  investment: InvestmentShape,
  isModalOpen: PropTypes.bool,
}

CustomerVerificationButton.defaultProps = {
  title: undefined,
  customer: undefined,
  onSuccess: () => {},
  investment: undefined,
  isModalOpen: false,
}

export default CustomerVerificationButton
